function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 164.26,
  cy: 64.87,
  r: 46.53
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 263.58,
  cy: 43.1,
  r: 43.1
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 347.61,
  cy: 58.63,
  r: 34.25
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 400.44,
  cy: 136.55,
  r: 51.6
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 76.22,
  cy: 126.46,
  r: 44.69
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 165.97,
  cy: 162.01,
  r: 44.81
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 252.42,
  cy: 435.91,
  r: 53.01
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 281.95,
  cy: 267.52,
  r: 40.57
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 193.01,
  cy: 252.71,
  r: 40.3
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 57.35,
  cy: 348.35,
  r: 37.98
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 306.05,
  cy: 122.51,
  r: 37.02
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 107.6,
  cy: 233.25,
  r: 41.09
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 35.63,
  cy: 270.52,
  r: 35.63
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 40.64,
  cy: 198.8,
  r: 29.39
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 251.77,
  cy: 185.97,
  r: 38.5
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 133.57,
  cy: 313.44,
  r: 37
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 232.38,
  cy: 114.5,
  r: 30.49
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 184.48,
  cy: 372.04,
  r: 33.31
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 349.02,
  cy: 412.83,
  r: 40.79
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 425.15,
  cy: 290.47,
  r: 35.33
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 157.75,
  cy: 438.44,
  r: 33.1
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 119.99,
  cy: 382.9,
  r: 26.85
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 291.8,
  cy: 349.11,
  r: 36.17
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 228.79,
  cy: 319.92,
  r: 28.43
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 420.63,
  cy: 358.83,
  r: 27.41
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 362.69,
  cy: 337.09,
  r: 27.76
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 357.9,
  cy: 275.02,
  r: 28.39
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 330.37,
  cy: 199.41,
  r: 34.45
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 399.52,
  cy: 224.79,
  r: 29.4
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 462.04,
  cy: 220.9,
  r: 26.97
});

function SvgBandvizLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 489.01 488.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandvizLogo);
export default __webpack_public_path__ + "static/media/bandviz-logo.b3415843.svg";
export { ForwardRef as ReactComponent };